angular.module('bribac.entities.insuranceCompanyFactory', [])
    .value('insuranceCompanyFactory', function insuranceCompanyFactory(data) {
        return angular.merge({
            name: null,
            address: null,
            city: null,
            state: null,
            zip: null,
            phone: null,
            mainGroupsIds: []
        }, data)
    })
